import { types } from "../types/types";

export const login = (data,token) => ({
    type: types.login,
    payload:{
        data,
        token
    }
}) 